import { createStore } from "vuex";
import { getCode } from "./api/utils";
import { IS_PRODUCTION } from "./libs/constants";
import { getAuthToken, getSiteData } from "./libs/auth-helper";

export default createStore({
  state: {
    // vue의 data객체와 같음
    errorData: null,
    siteData: null,
    gameInfo: {}
  },
  getters: {
    // vue의 computed와 같이 계산된 state의 값을 가져옴
    siteData(state) {
      return state.siteData;
    },
    gameList(state) {
      return state.gameList;
    }
  },
  mutations: {
    // state 값 변경 이벤트 로직 또는 메소드 ..commit()으로 동작, state의 상태변경을 위한 동기처리 로직을 담는다.
    setSiteData(state, value) {
      state.siteData = value;
    },
    setGameList(state, value) {
      state.gameList = value;
    },
    setErrorData(state, payload) {
      state.errorData = payload;
    },
    clearAllSiteData(state) {
      state.siteData = null;
    }
  },
  actions: {
    // store에 메소드를 등록하는 용도, state의 상태변경을 위한 비동기 처리 로직을 담는다.
    storeSiteData({ dispatch, commit }, payload) {
      const authToken = getAuthToken();
      if (authToken) {
        const siteData = JSON.parse(getSiteData());
        commit("setSiteData", siteData);
      }
    }
  },
  strict: IS_PRODUCTION
});
